import { render, staticRenderFns } from "./PopularPeople.vue?vue&type=template&id=355eddda&scoped=true&"
import script from "./PopularPeople.vue?vue&type=script&lang=js&"
export * from "./PopularPeople.vue?vue&type=script&lang=js&"
import style0 from "./PopularPeople.vue?vue&type=style&index=0&id=355eddda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355eddda",
  null
  
)

export default component.exports